import { useEffect } from 'react';
import AssessmentIntro from 'components/assessment-intro';
import { clearAssessmentData } from 'components/shared/utils';
import { useHistory } from 'react-router-dom';
import LottieAnimation from 'components/shared/LottieAnimation/LottieAnimation';

const DepressionSelfTest = (): JSX.Element => {
  const history = useHistory();
  const content = {
    title: 'Depression screener',
    description:
      'To complete this evaluation, think about your mental health experiences over the last two weeks.'
  };
  const LOTTIE_SEGMENTS: [number, number] = [120, 180];

  useEffect(() => {
    clearAssessmentData();
  }, []);

  const handleNextPage = () => {
    history.push('/depression-assessment');
  };

  return (
    <>
      <AssessmentIntro
        handleNextPage={handleNextPage}
        title={content.title}
        description={content.description}
        isStickyButton
      />
      <LottieAnimation segments={LOTTIE_SEGMENTS} />
    </>
  );
};

export default DepressionSelfTest;
